import { INT_RANGE_WITH_SPACE_AROUND_DASH_REGEX, POSITIVE_INT_REGEX } from '../../Integer/consts'

export function removeIntOrIntRange(
    array: { label: string; value: string }[],
    intOrIntRange: string
) {
    if (!intOrIntRange || !Array.isArray(array)) {
        return array
    }

    const cleaned = intOrIntRange.trim()

    if (POSITIVE_INT_REGEX.test(cleaned)) {
        const target = BigInt(cleaned)
        return array.filter((item) => BigInt(item.value) !== target)
    }

    const match = cleaned.match(INT_RANGE_WITH_SPACE_AROUND_DASH_REGEX)
    if (match) {
        const start = BigInt(match[1])
        const end = BigInt(match[2])

        if (start > end)
            throw new Error('Invalid range: start must be less than end')

        return array.filter(
            (item) =>
                BigInt(item.value) < start ||
                BigInt(item.value) > end
        )
    }

    throw new Error('Must be a single number or a range')
}
